import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import AppState from 'js/stores/AppState';
import { url } from 'js/services/Network';

import Modal from 'js/components/core/Modal';
import AppContent from 'js/components/AppContent';
import Backdrop from 'js/components/core/Backdrop';
import Constraint from 'js/components/Constraint';
import ErrorDisplay from 'js/components/common/ErrorDisplay';

import ItemDisplay from './ItemDisplay';
import OverallStatus from './OverallStatus';
import EditItem from './EditItem';
import HowItWorksDisplay from './HowItWorksDisplay';
import OfferList from './OfferList';
import OrdersList from 'js/components/pages/ManageItem/ItemStatusPage/OrdersList';
import CopyItem from 'js/components/core/CopyItem';
import analytics from 'js/services/Analytics';
import HowItWorks from 'js/components/pages/StatusPage/ItemStatusPage/HowItWorks';
import Pusher from 'pusher-js';

@inject('page')
@observer
export default class ItemStatusPage extends Component {

  constructor(props) {
    super(props);
    const pusher_app_key = process.env.MIX_PUSHER_APP_KEY;
    let MIX_PUSHER_APP_KEY = "e2f3f0f405d74c3ea3b1";
    this.pusher = new Pusher(MIX_PUSHER_APP_KEY, {
      wsHost: process.env.MIX_PUSHER_HOST ||  window.location.hostname,
      wsPort: process.env.MIX_PUSHER_PORT || 6001,
      wssPort: process.env.MIX_PUSHER_PORT || 6001,
      forceTLS: true, // Use strings to represent boolean in .env
      enabledTransports: ['wss','ws'],
      disableStats: false,
      cluster: 'eu',
      // debug: true
    });

  }
  componentDidMount() {

    if(process.env.MIX_PUSHER_APP_ENV !== 'production')
      Pusher.logToConsole = true;

    let channel = this.pusher.subscribe(`order.${this.props.page.alias}`);
    channel.bind('order-status-event', function(data) {
      console.log(data)
      window.location.reload();
    });

    AppState.setNav(
      AppState.previousPage === 'UserDashboardPage'
        ? {
          mode: 'back',
          text: 'Dashboard',
          url: url('user-dashboard-page'),
        }
        : this.props.page.is_seller
          ? {
            mode: 'back',
            text: 'My items',
            url: url('my-items'),
          }
          : { mode: 'normal' },
    );
  }

  componentWillUnmount() {
    this.pusher.unsubscribe(`order.${this.props.page.alias}`);
  }

  render() {
    const page = this.props.page;
    console.log('page',page);
    return (
      <>
        <AppContent padded>
          <Backdrop>
            <Constraint>
              {page.has_offers ? (
                <OverallStatus>Offers pending</OverallStatus>
              ) : (
                <OverallStatus>Waiting for a buyer</OverallStatus>
              )}

              <ItemDisplay />
            </Constraint>

            <ErrorDisplay>{page.error}</ErrorDisplay>
          </Backdrop>

          {page.has_offers ? (
            <Constraint>
              <OfferList />
            </Constraint>
          ) :  (
            <Constraint offset="3rem" bottomOffset="1.5rem">
              <CopyItem
                from={{ opacity: 0, position: 'relative' }}
                to={{ opacity: 1 }}
                title="Give this to your buyer:"
                text={page.payment_link_url}
                onCopy={() => {
                  analytics.track('CTA_SP_signed_up_manage_item_copy_item', {
                    'Item Price': page.price,
                    'Item Name': page.title,
                    'Payment Link': page.payment_link_url,
                    'Event Initiated by': AppState.currentPage === 'CreatePaymentLinkPage' || AppState.currentPage === 'SellerLandingPage'
                      ? 'seller' : 'buyer'
                  });
                }}
              />
              <HowItWorks onClick={page.showHowItWorks}>How does this work?</HowItWorks>
            </Constraint>
          )}

          {page.has_orders && (
            <Constraint offset="-1rem">
              <OrdersList />
            </Constraint>
          )}

        </AppContent>

        <Modal showModal={page.modalIsOpen} onCancel={page.closeModal} withCloseButton>
          <EditItem afterSave={page.afterSave} />
        </Modal>

        <Modal showModal={page.howItWorksIsOpen} onCancel={page.closeModal} withCloseButton>
          <HowItWorksDisplay />
        </Modal>
      </>
    );
  }
}
